class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// Omaggio Snurky: Gutschein automatico a 60 €,
// con possibilità di rimozione da parte del cliente.
(() => {
  const giftId = 57321557098874;
  const oldGiftId = 57315406709114;
  const threshold = 6000;
  const root = window.Shopify?.routes?.root || '/';

  const storageKey = `snurky_gift_${giftId}`;
  let running = false;
  let pending = false;
  let timer;
  let state = { seen: false, removed: false };

  try {
    const saved = JSON.parse(
      sessionStorage.getItem(storageKey) || 'null'
    );

    if (saved) {
      state.seen = saved.seen === true;
      state.removed = saved.removed === true;
    }
  } catch {}

  function saveState() {
    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify(state)
      );
    } catch {}
  }

  function isAutomatic(item) {
    return String(
      item.properties?._snurky_auto_gift || ''
    ) === '1';
  }

  async function request(path, body) {
    const response = await fetch(`${root}${path}`, {
      credentials: 'same-origin',
      ...(body ? {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      } : {})
    });

    if (!response.ok) {
      throw new Error(`Errore carrello: ${response.status}`);
    }

    return response.json();
  }

  async function syncGift() {
    if (running) {
      pending = true;
      return;
    }

    running = true;

    try {
      let cart = await request('cart.js');
      let changed = false;

      // Elimina soltanto le vecchie calze aggiunte
      // dal precedente codice come regalo automatico.
      const oldAutomaticGifts = cart.items.filter(
        item =>
          Number(item.variant_id) === oldGiftId &&
          isAutomatic(item)
      );

      for (const item of oldAutomaticGifts) {
        await request('cart/change.js', {
          id: item.key,
          quantity: 0
        });
        changed = true;
      }

      if (oldAutomaticGifts.length > 0) {
        cart = await request('cart.js');
      }

      // Nessuno dei due prodotti regalo contribuisce
      // al raggiungimento della soglia.
      const purchasedTotal = cart.items.reduce(
        (total, item) => {
          const variantId = Number(item.variant_id);

          if (
  variantId === giftId ||
  isAutomatic(item)
) {
  return total;
}


          return total + item.final_line_price;
        },
        0
      );

      const gifts = cart.items.filter(
        item => Number(item.variant_id) === giftId
      );

      const automaticGifts = gifts.filter(isAutomatic);

      // Se il regalo automatico era presente e ora manca,
      // considera la rimozione una scelta del cliente.
      if (
        state.seen &&
        automaticGifts.length === 0
      ) {
        state.removed = true;
      }

      state.seen = automaticGifts.length > 0;
      saveState();

      if (purchasedTotal < threshold) {
        // Questa è una rimozione automatica per soglia:
        // non deve essere interpretata come rinuncia.
        state.seen = false;
        saveState();

        for (const item of automaticGifts) {
          await request('cart/change.js', {
            id: item.key,
            quantity: 0
          });
          changed = true;
        }
      } else if (
        gifts.length === 0 &&
        !state.removed
      ) {
        await request('cart/add.js', {
          items: [{
            id: giftId,
            quantity: 1,
            properties: {
              _snurky_auto_gift: '1'
            }
          }]
        });

        state.seen = true;
        saveState();
        changed = true;
      }

      if (changed) {
        const sections = await request(
          'cart?sections=cart-drawer,cart-icon-bubble'
        );

        const drawer = document.querySelector(
          'cart-drawer'
        );

        if (
          drawer &&
          typeof drawer.renderContents === 'function' &&
          sections['cart-drawer']
        ) {
          drawer.renderContents({
            id: null,
            sections
          });
        }
      }
    } catch (error) {
      console.error('Omaggio Snurky:', error);
    } finally {
      running = false;

      if (pending) {
        pending = false;
        schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 250);
  }

  // Mantiene gli stessi collegamenti al carrello
  // presenti nel tuo codice originale.
  if (typeof CartDrawer !== 'undefined') {
    const originalRender =
      CartDrawer.prototype.renderContents;

    CartDrawer.prototype.renderContents = function (
      ...args
    ) {
      const result = originalRender.apply(this, args);
      schedule();
      return result;
    };
  }

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      schedule,
      { once: true }
    );
  } else {
    schedule();
  }
})();

